import { PriceButton } from "./PriceButton"
import { useState } from "react";
import { Button } from "./ui/button";
import { useModal } from "@/hooks/useModal";
import { PurchaseModal } from "./Modals/PurchaseModal";
import type { GameThemeId } from "@skillscratch/shared-types";
import type { Price } from "./Modals/PurchaseModal";
import { getStoreById } from "@/helpers/storeListings";


export function QuickBuySection() {
    // State to track the currently selected price, initialized with the initial price
    const [selectedPrice, setSelectedPrice] = useState<number | null>(null);

    const { openModal } = useModal();

    const handlePriceSelect = (price: number) => {
        setSelectedPrice(price);
    };

    const openPurchaseModal = () => {
        const id = `gold-card-${selectedPrice}` as GameThemeId;
        const listing = getStoreById(id as GameThemeId);
        openModal(<PurchaseModal id={id as GameThemeId} prices={listing?.prices as Price[]} priceId={id} key={id} />);
    }

    return (
        <>
            <div className='flex flex-row font-medium w-full justify-between mb-4'>
                <span>How many entries? (one time $1 /entry)</span>
            </div>
            <div className='space-y-2'>
                <div className='grid grid-cols-4 gap-2 w-full'>
                    <PriceButton 
                        price={15} 
                        isSelected={selectedPrice === 15} 
                        onClick={() => handlePriceSelect(15)} 
                    />
                    <PriceButton 
                        price={30} 
                        isSelected={selectedPrice === 30} 
                        onClick={() => handlePriceSelect(30)} 
                    />
                    <PriceButton 
                        price={60} 
                        isSelected={selectedPrice === 60} 
                        onClick={() => handlePriceSelect(60)} 
                    />
                    <PriceButton 
                        price={150} 
                        isSelected={selectedPrice === 150} 
                        onClick={() => handlePriceSelect(150)} 
                    />
                </div>
                <Button className="py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg"
                    onClick={() => openPurchaseModal()}>
                    Confirm
                </Button>
            </div>
        </>
    )
}